import { createActionRoute, createSiteRoute } from '@townsquare/router/create-route';

export const lookupRedirectActionRoute = createSiteRoute(
  createActionRoute({
    exact: true,
    name: 'lookupRedirectAction',
    path: '/lookup/:key',
  }),
);
